<div class="mp-wrap">
  <div class="mp-content">

    <div class="mp-copy">
      <div class="mp-logo-box">
        <app-logo-renderer></app-logo-renderer>
      </div>

      <span class="mp-eyebrow">
        <span class="mp-eyebrow-dot"></span>
        Scheduled maintenance
      </span>

      <h1 class="mp-title">We'll be right back</h1>
      <p class="mp-subtitle">
        We're making a few improvements behind the scenes. This shouldn't take long —
        please check back shortly.
      </p>

      <button type="button" class="mp-retry-btn" (click)="handleRetry()">
        <i class="bi bi-arrow-clockwise"></i>
        Try again
      </button>
    </div>

    <div class="mp-illustration" aria-hidden="true">
      <svg viewBox="0 0 520 420" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="260" cy="392" rx="200" ry="16" class="mp-svg-shadow" />

        <rect x="70" y="120" width="270" height="185" rx="14" class="mp-svg-panel" />
        <rect x="70" y="120" width="270" height="34" rx="14" class="mp-svg-panel-head" />
        <circle cx="88" cy="137" r="4.5" class="mp-svg-dot" />
        <circle cx="102" cy="137" r="4.5" class="mp-svg-dot" />
        <circle cx="116" cy="137" r="4.5" class="mp-svg-dot" />

        <rect x="92" y="174" width="140" height="10" rx="5" class="mp-svg-line" />
        <rect x="92" y="196" width="180" height="10" rx="5" class="mp-svg-line" />
        <rect x="92" y="218" width="110" height="10" rx="5" class="mp-svg-line" />

        <g class="mp-svg-gear mp-svg-gear--lg">
          <circle cx="300" cy="234" r="19" />
          <rect x="296" y="205" width="8" height="10" rx="1.5" transform="rotate(0 300 234)" />
          <rect x="296" y="205" width="8" height="10" rx="1.5" transform="rotate(45 300 234)" />
          <rect x="296" y="205" width="8" height="10" rx="1.5" transform="rotate(90 300 234)" />
          <rect x="296" y="205" width="8" height="10" rx="1.5" transform="rotate(135 300 234)" />
          <rect x="296" y="205" width="8" height="10" rx="1.5" transform="rotate(180 300 234)" />
          <rect x="296" y="205" width="8" height="10" rx="1.5" transform="rotate(225 300 234)" />
          <rect x="296" y="205" width="8" height="10" rx="1.5" transform="rotate(270 300 234)" />
          <rect x="296" y="205" width="8" height="10" rx="1.5" transform="rotate(315 300 234)" />
          <circle cx="300" cy="234" r="9" class="mp-svg-gear-hole" />
        </g>

        <g class="mp-svg-gear mp-svg-gear--sm">
          <circle cx="245" cy="280" r="13" />
          <rect x="242" y="259" width="6" height="8" rx="1.2" transform="rotate(0 245 280)" />
          <rect x="242" y="259" width="6" height="8" rx="1.2" transform="rotate(45 245 280)" />
          <rect x="242" y="259" width="6" height="8" rx="1.2" transform="rotate(90 245 280)" />
          <rect x="242" y="259" width="6" height="8" rx="1.2" transform="rotate(135 245 280)" />
          <rect x="242" y="259" width="6" height="8" rx="1.2" transform="rotate(180 245 280)" />
          <rect x="242" y="259" width="6" height="8" rx="1.2" transform="rotate(225 245 280)" />
          <rect x="242" y="259" width="6" height="8" rx="1.2" transform="rotate(270 245 280)" />
          <rect x="242" y="259" width="6" height="8" rx="1.2" transform="rotate(315 245 280)" />
          <circle cx="245" cy="280" r="6" class="mp-svg-gear-hole" />
        </g>

        <g class="mp-svg-wrench">
          <path d="M395 150c14-14 35-16 49-4l-22 22 12 12 22-22c12 14 10 35-4 49-16 16-40 17-56 3l-70 70a13 13 0 0 1-18-18l70-70c-14-16-13-40 3-56 4-4 9-7 14-9z" />
        </g>

        <g class="mp-svg-cone">
          <path d="M420 305l14-58a6 6 0 0 1 11.6 0l14 58z" />
          <rect x="422" y="298" width="35" height="9" rx="2" class="mp-svg-cone-band" />
          <rect x="410" y="303" width="59" height="12" rx="3" />
        </g>

        <circle cx="120" cy="72" r="15" class="mp-svg-accent-dot mp-svg-accent-dot--1" />
        <circle cx="435" cy="90" r="8" class="mp-svg-accent-dot mp-svg-accent-dot--2" />
        <rect x="380" y="60" width="18" height="18" rx="4" class="mp-svg-accent-dot mp-svg-accent-dot--3" />
      </svg>
    </div>

  </div>
</div>
